module.exports = __webpack_public_path__ + "img/about-img.943f22c5.jpg";